import { API_ENDPOINTS } from "../../enums/apiUrls";
import { getBearerToken } from "./bearerToken";

export const sendInviteViaEmail = async (email: string) => {
  const url = API_ENDPOINTS.SEND_INVITE_VIA_EMAIL;
  const body = {
    email: email,
    env: process.env.REACT_APP_ENV === "production" ? "production" : "staging",
  };
  const token = await getBearerToken();
  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error("Failed to send invite via email");
  }

  const data = await response.json();
  return data;
};
